import { Injectable } from '@angular/core';
import { DeepPartial, ESTENSA_MODULE_RADIO_SETTINGS_SERVICE } from '@se/platform';
import EstensaModel, { ObscuredTabType, OpenReportModeType, RadioSettings } from 'estensa-module';

@Injectable()
export class NullRadioSettingsService {
    MOCK_RADIO_SETTINGS: Partial<RadioSettings> = {
        cathlabSettings: {
            defaultStenosisOcclusionPercentage: 42,
        },
        collaborationSettings: {
            isEnabled: false,
            teamsProvider: undefined,
        },
        completeCdWorklistSettings: {
            searchTypeDefs: '[]',
            searchParamDefs: '[]',
            isRightPanelVisibleOnStart: false,
        },
        ecgSettings: {
            enableAlerts: false,
            alertSound: '',
            deltaSecondsToAcceptWarning: 0,
            disableOutOfFlowReporting: false,
            ecgVCColorSettings: undefined,
            enableSchillerFilters: false,
            isConclusionRequired: false,
            maxEcgToOpenTogether: 0,
            maxEcgToCompareInVC: 0,
            maxEcgToImportConclusionsFrom: 0,
            pediatricAgeThreshold: 0,
            printAsDisplayed: false,
            visibleDiagnosisInReporting: false,
            defaultSelectedTab: 0,
            isSeverityMandatory: false,
        },
        ecgWorklistSettings: {
            searchTypeDefs: '[]',
            searchParamDefs: '[]',
            isRightPanelVisibleOnStart: false,
        },
        enableDeferredReport: {
            enableDeferral: false,
            enableDeletion: false,
        },
        executionWorklistSettings: {
            searchParamDefs: '[]',
            searchTypeDefs: '[]',
            isRightPanelVisibleOnStart: false,
        },
        extensaSettings: {
            webApiPort: '9999',
            isWebApiEnabled: false,
        },
        healthPlatformSettings: {
            remoteVisitDescription: '',
            urlHttpAutoLogin: '',
            remoteVisitPermissionsPolicy: '',
        },
        onPrintingCdWorklistSettings: {
            searchTypeDefs: '[]',
            searchParamDefs: '[]',
            isRightPanelVisibleOnStart: false,
        },
        reportConfiguration: {
            obscuredTabType: ObscuredTabType.None,
            addendumReferringIsEnabled: false,
            confidentialityCodeDefault: false,
            canConfidentialityCodeBeModifiedPostApproval: false,
        },
        reportSettings: {
            signType: -1,
            closeReportAfterValidationOrSign: false,
            enableAnamnesticDataEditing: false,
            enableDedicatedWebViewerForRadiology: false,
            enableRemoteReporting: false,
            enableTimestamp: false,
            examsDescriptionInTextReport: EstensaModel.ExamsDescriptionInTextReportType.None,
            infocertSignTimeout: 0,
            isAddendumDisabled: false,
            isAuthenticationRequiredForUndoApproved: false,
            isAuthenticationUserRequiredOneTime: false,
            isAuthenticationRequiredForVNEXTApprove: false,
            isReportReasonForStudyMandatory: false,
            isDisabledUndoApproved: false,
            isReadOnlyReasonForStudy: false,
            printAfterApprove: false,
            reportImageActionType: EstensaModel.ImageActionType.Discard,
            textEditorFontSize: 0,
            reportDoseSettings: undefined,
            urlConsultation: '',
            signMode: 0,
            dedicatedWebViewerForVNextCardiology: undefined,
            dedicatedWebViewerForVNextRadiology: undefined,
        },
        specialtyWorklistSettings: {
            searchTypeDefs: '[]',
            searchParamDefs: '[]',
            isRightPanelVisibleOnStart: false,
        },
        visitWorklistSettings: {
            searchParamDefs: '[]',
            searchTypeDefs: '[]',
            isRightPanelVisibleOnStart: false,
        },
        viewerSettings: {
            webViewerType: null,
            webViewerTypeForCardioVNEXT: null,
            webViewerTypeForRadioVNEXT: null,
            brokerCheck: false,
            brokerCheckForCardioVNEXT: false,
            brokerCheckForRadioVNEXT: false,
            openInNewBrowserWindow: false,
            viewerInSingleStudyMode: false,
            viewerNeologicaSettings: undefined,
            viewerOsiriXSettings: undefined,
            viewereUnitySettings: undefined, 
            viewerSeWebSettings: undefined,
            viewerVueClientSettings: undefined,
        },
        vnaSettings: {
            enableImportDicom: false,
            enableImportNotDicom: false,
            vnaSettingBoxList: [],
        },
        worklistSettings: {
            openReportMode: OpenReportModeType.Standard,
            enableExaminationChangesSettings: {
                enableEditExamination: false,
                enableAddExamination: false,
                enableEditExam: false,
                enableDeleteExamination: false,
                enableNewExamination: false,
            },
            filterReferringPhysicians: false,
            autoOpenAdmissionExternalNumber: false,
            clearAdmissionExternalNumber: false,
            clearAdmissionNumber: false,
            clearPatient: false,
            enableAlertForDeferredReports: false,
            enableAdmissionBookingChangesSettings: undefined,
        },
    };

    getAsJSON(): Promise<DeepPartial<RadioSettings>> {
        // Questi sono i radio setting essenziali per far partire la standalone.
        return Promise.resolve(this.MOCK_RADIO_SETTINGS);
    }

    isExternalSigningEnabled() {
        return false;
    }
}

export function provideMockRadioSettingsService() {
    return {
        provide: ESTENSA_MODULE_RADIO_SETTINGS_SERVICE,
        useClass: NullRadioSettingsService,
    };
}
